import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import config from '../config'
import Amplitude from '../utils/amplitudeHelper'
import routes from '../routes'
import { useHistory } from 'react-router-dom'
import { FONTS, SIZES } from '../styles/theme'
import { toast } from 'react-toastify'
import { VotingAccessDb } from '../firebaseConfig'
import { useObject } from 'react-firebase-hooks/database'
import { useSelector, useDispatch } from 'react-redux'
import LoadIcon from '../components/LoadIcon'
import { getEntries } from '../ducks/entry'
import banner from '../images/backdrops/tiktok-banner.png'
import voteBtnHover from '../images/backdrops/vote-btn-hover.png'
import voteBtn from '../images/backdrops/vote-btn.png'
import prevBtn from '../images/backdrops/previous-btn.png'
import nextBtn from '../images/backdrops/next-btn.png'
import PreviewModal from '../components/PreviewModal'
import { SvgIcon } from 'src/components/shared/SvgIcon'
import { SvgType } from 'src/components/shared/SvgIcon/SvgIcon'
import TermsModal from 'src/components/TermsModal'

const PageWrapper = styled.div`
  opacity: 0;
  animation: appear 1s forwards;
  position: relative;
  font-family: ${FONTS.secondary};
  background-image: url(${config.assets.tiktok.landscape});
  background-size: cover;
  min-height: 100vh;
  height: 100%;
  overflow-y: scroll;
  #banner-container {
    position: relative;
    width: 35%;
    top: ${SIZES.navHeight};
    left: 0%;
    #tnc {
      position: absolute;
      background-color: #00B3BD;
      border: none;
      border-radius: 18px;    
      top: 76.5%;
      left: 45%;
      padding: 5px 10px;
      color: white;
      font-size: 80%;
      span {
        margin-right: 4px;
      }
      svg {
        width: 20px;
      }
    }
  }
  #poster-container {
    position: absolute;
    width: 60%;
    margin-top: ${SIZES.navHeight};
    top: 0%;
    left: 35%;
    right: 5%;
    padding-bottom: 50px;
  }
  .photo-container {
    display: flex;
    flex-wrap: wrap;
    
    p, span {
      margin: 0;
    }
    
    .participant-details {
      padding: 4px 18px;
      display: flex;
    }
    .entry-order {
      font-size: 32px;
      font-weight: 600;
      color: #00FFFF;
      margin-right: 12px;
      text-shadow: 2px 2px rgba(0, 0, 0, 0.2);
    }
    .entry-participant {
      color: white;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 600;
      text-shadow: 2px 2px rgba(0, 0, 0, 0.2);
    }

    .photo-box {
      padding: 0 24px;
      .entry-photo {
        cursor: pointer;
        position: relative;
        margin: 0px 4px;
        opacity: 0;
        animation: appear 1s forwards;
      }
    }
  }
  footer {
    width: 80%;
    margin: 12px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  nav {
    display: flex;
    justify-content: space-between;
    
    img {
      height: 6vh;
      margin: 0 8px;
      cursor: pointer;
    }
  }

  .vote-btn {
    cursor: pointer;
  }
  .pagenumber {
    cursor: pointer;
    color: #FFE400;
    font-size: 17px;
    font-weight: 500;
    margin: 0 5px;
    text-shadow: 2px 2px rgba(0, 0, 0, 0.2);
    opacity: 0.5;
  }
  .active {
    opacity: 1;
  }
`

export default function TikTokPage({ currentUser }) {
  const history = useHistory()
  const dispatch = useDispatch()
  const { entries, requestLoading } = useSelector((state) => state.entry)
  const [snapshot, loading, error] = useObject(VotingAccessDb)
  const [entriesByPage, setEntriesByPage] = useState([])
  const [pageNumber, setPageNumber] = useState(0)
  const [showPreview, setShowPreview] = useState(false)
  const [showTerms, setShowTerms] = useState(false)
  const [previewEntry, setPreviewEntry] = useState(null)
  const entriesArrangement = [ 4, 4, 4, 6, 6 ]
  
  
  useEffect(() => {
    document.title = `${config.eventName} | TikTok Challenge`
  }, [])

  useEffect(() => {
    if (!loading) {
      if (!snapshot.val() && currentUser.role === 'participant') {
        history.push(routes.lobby)
        toast('TikTok Challenge will be available soon.')
      } else {
        Amplitude.visit('TikTok')
      }
    }
  }, [loading, snapshot, history, currentUser.id])

  useEffect(() => {
    dispatch(getEntries())
  }, [dispatch])

  useEffect(() => {
    renderPageEntries()
  }, [entries, requestLoading])

  const renderPageEntries = () => {
    let splitArray = [];
    let count = 0
    for (let i = 0; i < entries?.length; i+= entriesArrangement[count]) {
      let startIndex = i
      if (startIndex === 14) startIndex = 12
      if (startIndex === 20) startIndex = 18
      let newChunk = entries.slice(startIndex, startIndex+entriesArrangement[count]);
      splitArray.push(newChunk)
      count++
    }
    setEntriesByPage(splitArray)
  }
  const previewVideo = (entry) => {
    setPreviewEntry(entry)
    setShowPreview(true)
  }
  const closePreview = () => {
    setShowPreview(false)
    setPreviewEntry(null)
  }
  const navPrev = () => {
    if (entriesByPage[pageNumber-1] !== undefined) {
      setPageNumber(pageNumber-1)
    }
  }
  const navNext = () => {
    if (entriesByPage[pageNumber+1] !== undefined) {
      setPageNumber(pageNumber+1)
    }
  }

  if (requestLoading) {
    return <LoadIcon />
  }
  return (
    <PageWrapper>
      <div id="banner-container">
        <img src={banner} width="95%" className="mx-auto" alt="contest banner" />
        <button id="tnc" onClick={()=>setShowTerms(true)}>
          <span>Terms & Conditions</span>
          <SvgIcon type={SvgType.PLAY} />
        </button>
      </div>
      <div id="poster-container">
        <div className={`photo-container`}>
          {(entriesByPage && entriesByPage[pageNumber] !=undefined) &&
          entriesByPage[pageNumber].map(entry=>(
            <div className={`grid-box ${entry.video_type == 0 ? "w-50" : "w-25"}`} key={`entry-${entry.id}`}>
              <div className="photo-box">
                <img src={entry.thumbnail.url} width="100%" className="entry-photo" onClick={()=>previewVideo(entry)}/>
              </div>
              <div className="participant-details">
                <h6 className="entry-order">{entry.order}</h6>
                <span className="entry-participant">{entry.name}</span>
              </div>
            </div>
          ))}
        </div>
        <footer>
          <div>
            <img 
              src={voteBtn} 
              className="vote-btn"
              width="200px" 
              onMouseOver={(e) => (e.currentTarget.src = voteBtnHover)}
              onMouseOut={(e) => (e.currentTarget.src = voteBtn)}
              alt="vote button"
              onClick={()=>history.push(routes.votingform)}
            />
          </div>
          <nav>
            <img src={prevBtn} style={{opacity: `${pageNumber === 0 ? '0' : '1'}`}} onClick={navPrev} alt="navigate button" />
            <div>
              {[0,1,2,3,4].map(page=>(
                <span className={`${pageNumber === page ? 'active' : ''} pagenumber`} onClick={()=>setPageNumber(page)}>{page+1}</span>
              ))}
            </div>
            <img src={nextBtn} style={{opacity: `${pageNumber === 4 ? '0' : '1'}`}} onClick={navNext} alt="navigate button" />
          </nav>
        </footer>
        {showPreview && <PreviewModal entry={previewEntry} showModal={showPreview} closeModal={closePreview}/>}
        {showTerms && <TermsModal showModal={showTerms} closeModal={()=>setShowTerms(false)}/>}
      </div>
    </PageWrapper>
  )
}
